<template>
  <div>
    <BaseGrid container>
      <BaseGrid :size="7">
        <Flex
          direction="column"
          :gap="0.25"
        >
          <BaseHeading>{{ title }}</BaseHeading>
          <BaseText>{{ description }}</BaseText>
        </Flex>
      </BaseGrid>
      <BaseGrid
        alignRight
        alignCenter
      >
        <BaseButton
          color="inverted"
          @click="goToRoute"
          v-test="`visit-${buttonRoute}`"
        >
          {{ buttonText }}
        </BaseButton>
      </BaseGrid>
    </BaseGrid>
  </div>
</template>

<script
  lang="ts"
  setup
>
import { defineProps } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { modal } from '@/helpers/ui';
import { useContactEmailVerification } from '../useContactEmailVerification';

const router = useRouter();

const props = defineProps<{
  title: string;
  description: string;
  buttonText: string;
  buttonRoute: string;
}>();

const { t } = useI18n();
const { contactEmailVerified, verifyContactEmail } =
  useContactEmailVerification();

const showVerificationModal = () => {
  modal('confirmation', {
    type: 'sendEmail',
    subMessage: t('email_templates.verification_modal.sub_message'),
    message: t('email_templates.verification_modal.message'),
  }).then(() => {
    verifyContactEmail();
  });
};

const goToRoute = () => {
  if (!contactEmailVerified) {
    showVerificationModal();
    return;
  }

  router.push({ name: props.buttonRoute });
};
</script>
